import * as React from "react";
import { Chip, Stack, Typography } from "@mui/material";
import LoadingIcon from "../icons/LoadingIcon";

const StateChip = ({
  color,
  label,
  textColor,
}: {
  color?:
    | "disabled"
    | "secondary"
    | "primary"
    | "error"
    | "info"
    | "success"
    | "warning"
    | "inherit"
    | "textPrimary"
    | "contrast"
    | undefined;
  label: string;
  textColor?: string;
}) => {
  return (
    <Chip
      label={
        <Stack alignItems={"center"} direction={"row"} gap={1}>
          <LoadingIcon size="xs" color={color ?? "textPrimary"} />
          <Typography color={textColor ?? "GrayText"}>{label}</Typography>
        </Stack>
      }
      variant="outlined"
      sx={{
        borderColor: textColor,
      }}
    />
  );
};

export default StateChip;
